import React from 'react';
import { Plus, FileSpreadsheet } from 'lucide-react';
import type { InventoryTypeFilter } from '../../../hooks/inventory-hooks/useInventoryPageState';
import { useLanguage } from '../../../features/language/useLanguage';
import { Button } from '../../../components/common/Button';

interface InventoryHeaderProps {
  typeFilter: InventoryTypeFilter;
  onAddItem: () => void;
  onImportGreenBean?: () => void;
  onImportRoastedBulk?: () => void;
  canWrite: boolean;
}

export const InventoryHeader: React.FC<InventoryHeaderProps> = ({
  typeFilter,
  onAddItem,
  onImportGreenBean,
  onImportRoastedBulk,
  canWrite,
}) => {
  const { t } = useLanguage();
  const showImport = canWrite && typeFilter === 'green_bean' && !!onImportGreenBean;
  const showImportRB =
    canWrite && typeFilter === 'roasted_bulk' && !!onImportRoastedBulk;
  const showAdd = canWrite && typeFilter !== 'finished_good' && typeFilter !== 'roasted_bulk';

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <h1 className="text-2xl font-semibold text-gray-900">{t('sidebar.inventory')}</h1>
      <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
        {showImport && (
          <Button
            variant="outline"
            data-test-id="inventory-import-green-bean-button"
            onClick={onImportGreenBean}
            leftIcon={<FileSpreadsheet className="h-4 w-4" />}
            className="w-full sm:w-auto"
          >
            {t('inventory.import.buttonLabel')}
          </Button>
        )}
        {showImportRB && (
          <Button
            variant="outline"
            data-test-id="inventory-import-roasted-bulk-button"
            onClick={onImportRoastedBulk}
            leftIcon={<FileSpreadsheet className="h-4 w-4" />}
            className="w-full sm:w-auto"
          >
            Import Roasted Bulk
          </Button>
        )}
        {showAdd && (
          <Button
            variant="primary"
            data-test-id="inventory-add-item-button"
            onClick={onAddItem}
            leftIcon={<Plus className="h-4 w-4" />}
            className="w-full sm:w-auto"
          >
            {t('inventory.header.addNewGreenBeanItem')}
          </Button>
        )}
      </div>
    </div>
  );
};
